export default {
    YESTERDAY: 'Yesterday',
    TODAY: 'Today',
    TOMORROW: 'Tomorrow',
    TODAYANDTOMORROW: 'Today, Tomorrow',
    TIME_ZONE: 'Pacific/Auckland',
};
